import type { TradeParams } from './trade-store';
import { create } from 'zustand';

export type SuspendedTrade = {
  attemptId: number;
  route: string;
  params: TradeParams;
};

export type TradeResumeState = {
  suspendedTrade?: SuspendedTrade;
  resumeNotice?: 'cancelled' | 'error';
  suspendTrade: (draft: SuspendedTrade) => void;
  takeSuspendedTrade: (attemptId: number, route: string) => SuspendedTrade | undefined;
  discardSuspendedTrade: () => void;
  setResumeNotice: (notice: TradeResumeState['resumeNotice']) => void;
};

// Drafts live only in memory. Pending transaction hashes have a separate lifecycle.
export const useTradeResumeStore = create<TradeResumeState>((set, get) => ({
  suspendTrade: draft => set({ suspendedTrade: { ...draft, params: { ...draft.params } }, resumeNotice: undefined }),
  takeSuspendedTrade: (attemptId, route) => {
    const draft = get().suspendedTrade;
    if (draft?.attemptId !== attemptId || draft.route !== route) return undefined;
    set({ suspendedTrade: undefined });
    return draft;
  },
  discardSuspendedTrade: () => set({ suspendedTrade: undefined, resumeNotice: undefined }),
  setResumeNotice: resumeNotice => set({ resumeNotice }),
}));
